import SSContactsFollow from "./contacts";

(function(){
  var stats_initialized = false;

  function setupStats() {
    if(stats_initialized) {
      return;
    }
    stats_initialized = true;
    var url_params = { id: slideshare_object.slideshow.id };
    if (slideshare_object.analytics_api_enabled) {
      $.ajax({
        type: 'GET',
        url: '/slideshow/stats',
        data: url_params,
        dataType: "json",
        success: function (data) {
          var $embeds = $('.j-info-embeds');
          var $embedsContainer = $embeds.find('.j-embeds-container');
          $('.j-slideshare-views').text(data.slideshow_analytics_on_ss);
          $('.j-embed-views').text(data.slideshow_analytics_views_from_embeds);
          if (data.slideshow_analytics_top_embeds.length > 0) {
            for (var i = 0; i < data.slideshow_analytics_top_embeds.length; i++) {
              var emb = data.slideshow_analytics_top_embeds[i];
              $embedsContainer.append('<div class="small-8 columns stat-label">' + emb.url +
                '</div><div class="small-4 columns stat-value text-right">' + emb.hits + '</div>');
            }

            $embeds.find('.j-no-embeds').remove();
            $embedsContainer.show();
          }
        }
      });
    }
  }

  $('#slideshow-views-modal-trigger').on('click', function() {
    setupStats();
  });
  
  var ssContactsFollow = new SSContactsFollow(slideshare_object);
  var ssSuperUser = null;

  slideshare_object.setup_flagging_interaction();

  slideshare_object.clippingTracker = new slideshare_object.ClippingTracker({
    userIsOwner: slideshare_object.user && slideshare_object.user.loggedin
  });
})();
